var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatSetsUsApartRightTriangleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 504,
    viewBox: "0 0 217 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53035 23.1084C-3.55965 10.2004 9.01809 -3.61801 22.4404 1.23439L512.004 178.22C522.72 182.094 526.067 195.61 518.397 204.037L250.959 497.855C243.289 506.282 229.518 504.218 224.656 493.912L2.53035 23.1084Z",
    fill: "url(#paint0_linear_304:2253)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304:2253",
    x1: -14.0063,
    y1: -11.9417,
    x2: 517.573,
    y2: 471.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B7B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatSetsUsApartRightTriangleBlue);
export default __webpack_public_path__ + "static/media/what-sets-us-apart-right-triangle-blue.346f3ac0.svg";
export { ForwardRef as ReactComponent };